export function minifyGraphQLQuery(query: string) {
  let minified = query
    .replace(/#.*$/gm, '') // Remove # line comments
    .replace(/\/\*[\s\S]*?\*\//g, '') // Remove /* */ block comments
    .replace(/\s+/g, ' ') // Replace multiple spaces/newlines with a single space
    .replace(/\s*([{}(),:])\s*/g, '$1') // Remove spaces around GraphQL operators and punctuation
    .replace(/\s*\.\.\.\s*/g, '...') // Remove spaces around fragment spread and inline fragments
    .replace(/\s*@\s*/g, '@') // Remove spaces around directives
    .replace(/\s*\$\s*/g, '$') // Remove spaces around variable definitions
    .trim(); // Remove leading and trailing spaces

  minified = minified.replace(/"([^"\\]|\\.)*"/g, match => {
    return match.replace(/\s+/g, ' '); // Preserve spaces inside quoted strings
  });

  return minified;
}
